export default __webpack_public_path__ + "static/svelte-6bc6e5cd39100268bb7091c56ec6c3ae.webp";